import { render } from "./SlidingSwitch.vue?vue&type=template&id=59511f48&scoped=true"
import script from "./SlidingSwitch.vue?vue&type=script&lang=js"
export * from "./SlidingSwitch.vue?vue&type=script&lang=js"

import "./SlidingSwitch.vue?vue&type=style&index=0&id=59511f48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59511f48"]])

export default __exports__